"use client";
import React, { useState } from "react";
import Link from "next/link";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Github, Linkedin } from "lucide-react";
import { cn } from "@/lib/utils";

const NavLink = ({ href, children, mobile = false, onClick }) => (
  <Link
    href={href}
    onClick={onClick}
    className={cn(
      "text-sm font-medium transition-colors hover:text-primary",
      mobile
        ? "block py-3 text-lg text-muted-foreground"
        : "text-muted-foreground"
    )}
  >
    {children}
  </Link>
);

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <motion.nav
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "circOut" }}
        className="fixed top-6 left-0 right-0 z-50 flex justify-center px-4"
      >
        <div className="flex items-center justify-between w-full max-w-3xl px-6 py-3 bg-black/50 backdrop-blur-xl border border-white/10 rounded-full shadow-lg">
          <Link href="/" className="text-lg font-bold tracking-tighter text-white">
            ADHWAITH<span className="text-muted-foreground">.DEV</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8">
            <NavLink href="/#about">About</NavLink>
            <NavLink href="/projects">Work</NavLink>
            <NavLink href="/#contact">Contact</NavLink>
            <a
              href="/resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-white transition-colors"
            >
              Resume
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-4">
            <Link href="https://github.com/adhwaithas" target="_blank" className="text-muted-foreground hover:text-white transition" aria-label="GitHub">
              <Github size={20} />
            </Link>
            <Link href="https://linkedin.com/in/adhwaithas" target="_blank" className="text-muted-foreground hover:text-white transition" aria-label="LinkedIn">
              <Linkedin size={20} />
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-muted-foreground hover:text-white"
          >
            {isOpen ? <X /> : <Menu />}
          </button>
        </div>
      </motion.nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="fixed inset-0 z-40 bg-black pt-24 px-6 md:hidden"
          >
            <div className="flex flex-col space-y-4">
              <NavLink href="/#about" mobile onClick={() => setIsOpen(false)}>About</NavLink>
              <NavLink href="/projects" mobile onClick={() => setIsOpen(false)}>Work</NavLink>
              <NavLink href="/#contact" mobile onClick={() => setIsOpen(false)}>Contact</NavLink>
              <a
                href="/resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsOpen(false)}
                className="block py-3 text-lg text-muted-foreground hover:text-white transition-colors"
              >
                Resume
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
